/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { makeAutoObservable } from 'mobx'
import { putPermissions } from '@services/api/userAPI'

class AccessControlStore {
  acl = {}
  // users = mockUsers
  savingAclError = false
  savingAcl = false
  constructor() {
    makeAutoObservable(this, {}, { autoBind: true })
  }

  toggleRoleAccessAtProduct(reportId, sectionId, userId) {
    try {
      if (!this.acl[reportId]) {
        this.acl[reportId] = {
          roles: {
            [sectionId]: {
              users: {
                [userId]: false,
              },
            },
          },
        }
      } else if (!this.acl[reportId].roles[sectionId]) {
        this.acl[reportId].roles[sectionId] = {
          users: {
            [userId]: false,
          },
        }
      } else if (!this.acl[reportId].roles[sectionId].users[userId]) {
        this.acl[reportId].roles[sectionId].users[userId] = true
      } else {
        this.acl[reportId].roles[sectionId].users[userId] =
          !this.acl[reportId].roles[sectionId].users[userId]
      }
    } catch (e) {
      console.error(e)
      this.error = 'Invalid'
    }
  }

  saveAccessControl = async () => {
    try {
      this.savingAclError = false
      this.savingAcl = true
      await putPermissions({
        permissions: this.acl,
        planId: 4888,
        productId: 'pa',
      })
    } catch (error) {
      this.savingAclError = true
    } finally {
      this.savingAcl = false
    }
  }

  // TODO
  // eslint-disable-next-line no-unused-vars
  addRoleToDashboard(productId, roleId, userId) {}

  // TODO
  // eslint-disable-next-line no-unused-vars
  revokeDashboardAccess(productId, roleId, userId) {}
}

export default AccessControlStore
